<template>
  <b-card>
    <b-row>
      <b-col class="col-9" />
      <b-col class="col-3">
        <download-em-lote
          :tipo-arquivo="`todos os parcelamentos MEI`"
          :tipo="`Parcelamento MEI  `"
          style="white-space: nowrap;"
          @baixar-lote="baixarEmLote"
        />
      </b-col>
    </b-row>
    <parcelamento-list
      ref="parcelamentoList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :mostrar-acoes-padrao="false"
      :filtros-rapidos="filtrosRapidos"
      :tem-limpar-filtros="true"
    >
      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <b-badge
          v-if="props.column.field === 'situacao'"
          :variant="getColorTag(props.row[props.column.field])"
          @click.stop="openAlertAvisoSituacao(props.row)"
        >
          <div :style="props.row[props.column.field].length > 26 ? 'width: 180px; white-space: normal;' : 'max-width: 180px;'">
            {{ props.row[props.column.field] }}
          </div>
        </b-badge>
        <span
          v-else-if="props.column.field === 'razaoSocial'"
          @click.stop="$refs[`acoes${props.row.id}`].abrirArquivo(props.row)"
        >
          {{ props.formattedRow[props.column.field] }}
        </span>
        <div>
          <b-badge
            v-if="props.column.field === 'parcelasEmAtraso'"
            :variant="props.row[props.column.field] == true ? 'light-danger' : 'light-success'"
          >
            {{ props.row[props.column.field] == true ? 'Sim' : 'Não' }}
          </b-badge>
          <div
            v-else-if="props.column.field === 'nroUltimaParcelaDe'"
            :id="`nmrParcela${props.row.id}`"
            class="alinhar-coluna"
            style="display: inline-flex;"
          >
            <span
              class="mr-50"
              style="white-space: nowrap;"
            >
              {{ props.row[props.column.field] }}
            </span>
            <b-tooltip
              v-if="props.row[props.column.field].includes('-')"
              :target="`nmrParcela${props.row.id}`"
              title="O parcelamento não se encontra liberado para impressão das guias. As parcelas serão disponibilizadas assim que forem liberadas no portal do ECAC."
            />
          </div>
        </div>

      </template>
      <template
        slot="acoes"
        slot-scope="{ props} "
      >
        <acoes
          :ref="`acoes${props.row.id}`"
          :grid-props="props"
          :request-parcelas="getParcelas"
          :request-enviar-email="enviaParcelaEmail"
          :request-guia-parcelamento="getGuiaParcelamento"
          :tipo-parcelamento="tipoParcelamento"
          :api="apiParcelamento(tipoParcelamento)"
        />
      </template>
    </parcelamento-list></b-card>
</template>
<style>
.alinhar-coluna {
  text-align: center !important;
}
</style>
<script>
import envioHistoricoApi from '@app/shared/services/envio-historico-api'
import notificarBaixaLote from '@app/shared/utils/baixaEmLoteToast'
import colunas from '../config/colunas'
import filtrosRapidosConfig from '../config/filtrosRapidos'
import filtroColunasConfig from '../config/filtrosColunas'

import service from '../services/parcelamentosMeiService'
import useAviso from '../components/aviso/useAviso'

export default {
  components: {
    ParcelamentoList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Acoes: () => import('../components/acoes/Acoes.vue'),
    DownloadEmLote: () => import('@app/download-lote/DownloadEmLote.vue'),
  },
  data() {
    return {
      botoesOption: null,
      linha: null,
      visualizacao: {
        acaoClass: 'col-td-acao-4',
        disabledCheckbox: true,
        placeholderBusca: 'Buscar por: CNPJ/CPF e Razão social',
      },
      filtros: [
        {
          colunas: filtroColunasConfig,
          valor: null,
        },
      ],
      filtrosRapidos: filtrosRapidosConfig,
      criando: true,
      tipoParcelamento: '',
      filtroAtual: {},
      apiParcelamento: service,
    }
  },
  computed: {
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  created() {
    this.tipoParcelamento = this.$route.meta.tipo
    this.visualizacao.colunas = colunas
    this.visualizacao.evento = this.carregar
  },
  methods: {
    openAlertAvisoSituacao(row) {
      if (row.situacao === 'CPF sem dados' || row.situacao === 'Sem acesso para filial') {
        useAviso(row)
      }
    },
    getColorTag(value) {
      if (this.getColorCustom) {
        return this.getColorCustom(value)
      }

      if (value === 'Em parcelamento' || value === 'Deferida e consolidada') {
        return 'light-primary'
      }
      if (value === 'Em parcelamento - Aguardando confirmação de remanescentes') {
        return 'light-danger'
      }
      return 'light-warning'
    },
    carregar(pagina, tamanhoPagina, filtro) {
      this.filtroAtual = filtro
      return service(this.tipoParcelamento).getPaginado(pagina, tamanhoPagina, filtro).then(async response => {
        if (response.data && response.data.valores && response.data.valores.length > 0) {
          const ids = response.data.valores.map(i => i.id)
          const tipoRotinaId = 28 // ParcelamentoRelpMei
          try {
            const statusResp = await envioHistoricoApi.obterStatus(tipoRotinaId, ids)
            const statusMap = {}
            if (statusResp.data) {
              statusResp.data.forEach(s => { statusMap[s.idRegistro] = s })
            }
            response.data.valores.forEach(item => {
              const status = statusMap[item.id]
              if (status) {
                this.$set(item, 'whatsappEnviado', status.whatsappEnviado)
                this.$set(item, 'emailEnviado', status.emailEnviado)
              }
            })
          } catch (err) {
            this.$erro(err)
          }
        }
        return response
      })
    },
    getParcelas(parcelamentoId) {
      return service(this.tipoParcelamento).getParcelas(parcelamentoId)
    },
    getParcelasRecentes(parcelamentoId) {
      return service(this.tipoParcelamento).getParcelasRecentes(parcelamentoId)
    },
    enviaParcelaEmail(nomeEmpresa, emailEmpresa, emailCc, id, parcelaId, mensagemAdicional, definirEmailPadrao) {
      return service(this.tipoParcelamento).enviarEmail(nomeEmpresa, emailEmpresa, emailCc, id, parcelaId, mensagemAdicional, definirEmailPadrao)
    },
    getGuiaParcelamento(parcelamentoId, parcelaId) {
      return service(this.tipoParcelamento).getGuiaParcela(parcelamentoId, parcelaId)
        .then(payload => {
          if (payload.data === 'New request') {
            return service(this.tipoParcelamento).getGuiaParcela(parcelamentoId, parcelaId)
          }
          return payload
        })
    },
    baixarEmLote(evt) {
      notificarBaixaLote(service(this.tipoParcelamento).baixaEmLote(this.filtroAtual, evt))
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.parcelamentoList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.parcelamentoList.aplicarFiltro(params.busca, filtroRapido)
        }
      })
    },
  },
}
</script>
